module.exports = __webpack_public_path__ + "static/img/giftbox.df8cdd31.webp";